import { render } from "./Lds.vue?vue&type=template&id=c110488c&scoped=true"
import script from "./Lds.vue?vue&type=script&lang=js"
export * from "./Lds.vue?vue&type=script&lang=js"

import "./Lds.vue?vue&type=style&index=0&id=c110488c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c110488c"]])

export default __exports__